import * as moment from "moment";

export function writeCookie(name: string, value: string, duration?: moment.Duration): void {
    const expiresString = duration ? toExpiresString(duration) : "";
    const cookieValue = `${name}=${value}${expiresString}; path = /`;
    document.cookie = cookieValue;
}

function toExpiresString(duration: moment.Duration): string {
    const expires = moment().add(duration);
    return `; expires=${expires.toDate().toUTCString()}`;
}

export function readCookie(name: string): string | undefined {
    const expectedPrefix = `${name}=`;
    const cookieParts = document.cookie.split(";");
    const match = cookieParts.find((part) => part.indexOf(expectedPrefix) >= 0);

    if (!match) {
        return undefined;
    }

    return match.trim().substr(expectedPrefix.length);
}

export function deleteCookie(name: string): void {
    writeCookie(name, "", moment.duration(-1, "s"));
}
